import React from "react";
import { CurrencyFormatter } from "@/i18n/currency";
import type { tMoney } from "@/types";

type tProps = {
  price: tMoney;
};
const TaskPrice = (props: tProps) => {
  return (
    <div
      css={`
        align-items: center;
        position: absolute;
        top: 40px;
        right: 5px;
        font-size: 14px;
        color: white;
        display: flex;
      `}
    >
      <div
        css={`
          border-radius: var(--root-br);
          padding: 5px;
          background: var(--color-primary);
        `}
      >
        {CurrencyFormatter.format(props.price)}
      </div>
    </div>
  );
};

export default TaskPrice;
